import * as React from "react";
import { SVGProps } from "react";

export const ArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={41}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="#A3A3A6"
      d="m24.303 29.942 2.336-2.336L19.05 20l7.59-7.606-2.337-2.337L14.36 20l9.942 9.942Z"
    />
  </svg>
);
